import { returnsProducts } from '@avalara/bat-apps-shared/constants';
import { formatPrice } from '../../shared/helpers';
import { getSalestaxDisplayText } from '../reducers/helpers';

import type { State } from '@avalara/types/reducer-states';

export const selectReturnsPricingData = ({ order, returns }: State) => {
  const salestax = typeof returns.salestax === 'number' ? returns.salestax : 0;

  const { subscriptionPrice, pricePerReturn } = returnsProducts;
  const discountAmount = (subscriptionPrice * (order.discountPercent || 0)) / 100;
  const orderSubtotal = subscriptionPrice - discountAmount;
  const total = orderSubtotal + salestax;
  const salestaxDisplayText = getSalestaxDisplayText(returns.salestax);

  return {
    discountAmount,
    pricePerReturn: formatPrice(pricePerReturn),
    subtotal: subscriptionPrice,
    subtotalDisplayText: formatPrice(subscriptionPrice),
    subscriptionPrice,
    salestax,
    salestaxDisplayText,
    total,
    totalPrice: formatPrice(total),
  };
};
